import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.for-each.js";
var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/features/compose/components/privacy_dropdown.tsx";
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.map.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import classNames from 'classnames';
import { supportsPassiveEvents } from 'detect-passive-events';
import React, { useState, useRef, useEffect, useCallback } from 'react';
import ReactDOM from 'react-dom';
import { useIntl, defineMessages } from 'react-intl';
import { usePopper } from 'react-popper';
import { IconButton, Icon } from 'soapbox/components/ui';
import { useFeatures, useLogo } from 'soapbox/hooks';
const messages = defineMessages({
  public_short: {
    "id": "privacy.public.short",
    "defaultMessage": "Public"
  },
  public_long: {
    "id": "privacy.public.long",
    "defaultMessage": "Post to public timelines"
  },
  unlisted_short: {
    "id": "privacy.unlisted.short",
    "defaultMessage": "Unlisted"
  },
  unlisted_long: {
    "id": "privacy.unlisted.long",
    "defaultMessage": "Do not post to public timelines"
  },
  local_short: {
    "id": "privacy.local.short",
    "defaultMessage": "Local-only"
  },
  local_long: {
    "id": "privacy.local.long",
    "defaultMessage": "Status is only visible to people on this instance"
  },
  private_short: {
    "id": "privacy.private.short",
    "defaultMessage": "Followers-only"
  },
  private_long: {
    "id": "privacy.private.long",
    "defaultMessage": "Post to followers only"
  },
  direct_short: {
    "id": "privacy.direct.short",
    "defaultMessage": "Direct"
  },
  direct_long: {
    "id": "privacy.direct.long",
    "defaultMessage": "Post to mentioned users only"
  },
  change_privacy: {
    "id": "privacy.change",
    "defaultMessage": "Adjust post privacy"
  }
});
const listenerOptions = supportsPassiveEvents ? {
  passive: true
} : false;
const PrivacyDropdownMenu = ({
  style,
  items,
  value,
  onClose,
  onChange,
  reference
}) => {
  const [node, setNode] = useState(null);
  const focusedItem = useRef(null);
  const {
    top
  } = reference.getBoundingClientRect();
  const {
    attributes,
    styles
  } = usePopper(reference, node, {
    placement: top * 2 < window.innerHeight ? 'bottom' : 'top'
  });
  const handleDocumentClick = useCallback(e => {
    if (node && !node.contains(e.target)) {
      onClose();
    }
  }, [node, onClose]);
  const handleKeyDown = e => {
    const value = e.currentTarget.getAttribute('data-index');
    const index = items.findIndex(item => item.value === value);
    let element = null;
    switch (e.key) {
      case 'Escape':
        onClose();
        break;
      case 'Enter':
        handleClick(e);
        break;
      case 'ArrowDown':
        element = node?.childNodes[index + 1] || node?.firstChild;
        break;
      case 'ArrowUp':
        element = node?.childNodes[index - 1] || node?.lastChild;
        break;
      case 'Tab':
        if (e.shiftKey) {
          element = node?.childNodes[index - 1] || node?.lastChild;
        } else {
          element = node?.childNodes[index + 1] || node?.firstChild;
        }
        break;
      case 'Home':
        element = node?.firstChild;
        break;
      case 'End':
        element = node?.lastChild;
        break;
    }
    if (element) {
      element.focus();
      onChange(element.getAttribute('data-index'));
      e.preventDefault();
      e.stopPropagation();
    }
  };
  const handleClick = e => {
    const value = e.currentTarget?.getAttribute('data-index');
    e.preventDefault();
    onClose();
    onChange(value);
  };
  useEffect(() => {
    document.addEventListener('click', handleDocumentClick, false);
    document.addEventListener('touchend', handleDocumentClick, listenerOptions);
    focusedItem.current?.focus({
      preventScroll: true
    });
    return () => {
      document.removeEventListener('click', handleDocumentClick, false);
      document.removeEventListener('touchend', handleDocumentClick);
    };
  }, [handleDocumentClick]);
  return /*#__PURE__*/ReactDOM.createPortal(/*#__PURE__*/React.createElement("div", _extends({
    className: 'privacy-dropdown__dropdown absolute bg-white dark:bg-slate-900 z-[1000] rounded-md shadow-lg ml-10 text-sm',
    style: _objectSpread(_objectSpread({}, style), styles.popper),
    role: "listbox",
    ref: setNode
  }, attributes.popper, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 115,
      columnNumber: 5
    }
  }), items.map(item => /*#__PURE__*/React.createElement("div", {
    role: "option",
    tabIndex: 0,
    key: item.value,
    "data-index": item.value,
    onKeyDown: handleKeyDown,
    onClick: handleClick,
    className: classNames('privacy-dropdown__option', {
      active: item.value === value
    }),
    "aria-selected": item.value === value,
    ref: item.value === value ? focusedItem : null,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 117,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "privacy-dropdown__option__icon",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 118,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    size: 16,
    src: item.icon,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 119,
      columnNumber: 13
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "privacy-dropdown__option__content",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 122,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement("strong", {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 123,
      columnNumber: 13
    }
  }, item.text), item.meta)))), document.body);
};
const PrivacyDropdown = ({
  isUserTouching,
  onChange,
  onModalClose,
  onModalOpen,
  value,
  unavailable
}) => {
  const intl = useIntl();
  const [node, setNode] = useState(null);
  const activeElement = useRef(null);
  const logo = useLogo();
  const features = useFeatures();
  const [open, setOpen] = useState(false);
  const options = [{
    icon: require('@tabler/icons/world.svg'),
    value: 'public',
    text: intl.formatMessage(messages.public_short),
    meta: intl.formatMessage(messages.public_long)
  }, {
    icon: require('@tabler/icons/eye-off.svg'),
    value: 'unlisted',
    text: intl.formatMessage(messages.unlisted_short),
    meta: intl.formatMessage(messages.unlisted_long)
  }, ...(features.localOnlyPrivacy ? [{
    icon: logo,
    value: 'local',
    text: intl.formatMessage(messages.local_short),
    meta: intl.formatMessage(messages.local_long)
  }] : []), {
    icon: require('@tabler/icons/lock.svg'),
    value: 'private',
    text: intl.formatMessage(messages.private_short),
    meta: intl.formatMessage(messages.private_long)
  }, {
    icon: require('@tabler/icons/mail.svg'),
    value: 'direct',
    text: intl.formatMessage(messages.direct_short),
    meta: intl.formatMessage(messages.direct_long)
  }];
  const handleToggle = e => {
    if (isUserTouching()) {
      if (open) {
        onModalClose();
      } else {
        onModalOpen({
          actions: options.map(option => _objectSpread(_objectSpread({}, option), {}, {
            active: option.value === value
          })),
          onClick: handleModalActionClick
        });
      }
    } else {
      if (open) {
        activeElement.current?.focus();
      }
      setOpen(!open);
    }
    e.stopPropagation();
  };
  const handleModalActionClick = e => {
    e.preventDefault();
    const {
      value
    } = options[e.currentTarget.getAttribute('data-index')];
    onModalClose();
    onChange(value);
  };
  const handleKeyDown = e => {
    switch (e.key) {
      case 'Escape':
        handleClose();
        break;
    }
  };
  const handleMouseDown = () => {
    if (!open) {
      activeElement.current = document.activeElement;
    }
  };
  const handleButtonKeyDown = e => {
    switch (e.key) {
      case ' ':
      case 'Enter':
        handleMouseDown();
        break;
    }
  };
  const handleClose = () => {
    if (open) {
      activeElement.current?.focus();
    }
    setOpen(false);
  };
  if (unavailable) {
    return null;
  }
  const valueOption = options.find(item => item.value === value);
  return /*#__PURE__*/React.createElement("div", {
    className: classNames('privacy-dropdown', {
      active: open
    }),
    onKeyDown: handleKeyDown,
    ref: setNode,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 231,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames('privacy-dropdown__value', {
      active: valueOption && options.indexOf(valueOption) === 0
    }),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 232,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(IconButton, {
    className: "text-gray-400 hover:text-gray-600",
    src: valueOption?.icon,
    title: intl.formatMessage(messages.change_privacy),
    onClick: handleToggle,
    onMouseDown: handleMouseDown,
    onKeyDown: handleButtonKeyDown,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 233,
      columnNumber: 9
    }
  })), open && /*#__PURE__*/React.createElement(PrivacyDropdownMenu, {
    items: options,
    value: value,
    onClose: handleClose,
    onChange: onChange,
    reference: node,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 245,
      columnNumber: 11
    }
  }));
};
export default PrivacyDropdown;